import { fg } from '@atlaskit/platform-feature-flags';
import { getConfig } from '@atlassian/teams-common/context-config';

import RestClient from './rest-client';

export class TeamCentralRestClient extends RestClient {
	constructor() {
		super({ serviceUrl: getConfig().stargateRoot });
	}

	async hasWorkspaceForCloudId(cloudId: string): Promise<boolean> {
		const maybeShardedPrefix = this.buildMaybeShardedPrefix(cloudId);
		try {
			await this.getResource(`${maybeShardedPrefix}/workspace/exists?cloudId=${cloudId}`);
			return true;
		} catch (err) {
			return false;
		}
	}

	async doesOrgContainAnyWorkspace(cloudId: string): Promise<boolean> {
		const maybeShardedPrefix = this.buildMaybeShardedPrefix(cloudId);
		try {
			await this.getResource(
				`${maybeShardedPrefix}/organization/containsAnyWorkspace?cloudId=${cloudId}`,
			);
			return true;
		} catch (err) {
			return false;
		}
	}

	async isGlobalExperienceWorkspaceForCloudId(cloudId: string): Promise<boolean> {
		const maybeShardedPrefix = this.buildMaybeShardedPrefix(cloudId);
		try {
			const res = await this.makeRequest(
				`${maybeShardedPrefix}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`,
				{
					headers: {
						Accept: 'text/plain',
					},
				},
			);

			return Promise.resolve(res === 'GLOBAL_EXPERIENCE');
		} catch (err) {
			return Promise.resolve(false);
		}
	}

	private buildMaybeShardedPrefix(cloudId: string): string {
		if (fg('enable_ptc_sharded_townsquare_calls')) {
			return `/townsquare/s/${cloudId}`;
		} else {
			return '/watermelon';
		}
	}
}

/**
 * REST Client to make calls to resources on the team central service.
 *
 * Note: You probably don't want to use this directly. Use the centralised store instead where these values
 * have already been fetched. See useTeamCentralStore().
 *
 * @type {RestClient}
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default new TeamCentralRestClient();
